import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Jsa } from '../../../../services/jsa/jsa.interface';
import { JsaService } from '../../../../services/jsa/jsa.service';
import { JsaPaper } from '../../../../services/jsaPaper/jsaPaper.interface';
import { JsaPaperService } from '../../../../services/jsaPaper/jsaPaper.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-reports',
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatInputModule,
        MatRadioModule,
        MatFormFieldModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelect,
        MatOption,
        MatDatepickerModule,
        MatTableModule,
        MatIconModule
    ],
    templateUrl: './reports.component.html',
    styleUrl: './reports.component.css'
})
export class ReportsComponent implements OnInit {
  form: FormGroup;
  displayedColumns: string[] = ['office', 'time', 'date', 'projectNumber', 'clientName', 'signature'];
  displayedColumnsPaper: string[] = ['office', 'name', 'date', 'fileUrl'];
  dataSource = new MatTableDataSource<Jsa>();
  paperDataSource = new MatTableDataSource<JsaPaper>();
  totalSubmissions = 0;
  searchConducted = false;
  isLoading = false; // Track loading state

  constructor(private fb: FormBuilder, private jsaService: JsaService, private jsaPaperService: JsaPaperService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      office: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    });
  }

  onSubmit(): void {
    this.searchConducted = true;
    this.isLoading = true; 

    // Clear the table data before a new search
    this.dataSource.data = [];
    this.paperDataSource.data = [];
    this.totalSubmissions = 0;

    if (this.form.valid) {
      const { office, startDate, endDate } = this.form.value;

      forkJoin({
        jsaData: this.jsaService.searchJsaReport(office, startDate, endDate),
        jsaPaperData: this.jsaPaperService.searchJsaPaperReport(office, startDate, endDate)
      }).subscribe({
        next: (results: any) => {
          this.dataSource.data = [...results.jsaData.data].sort(
            (a: any, b: any) =>
              new Date(b.userDateTime ?? b.date).getTime() -
              new Date(a.userDateTime ?? a.date).getTime()
          );
          this.paperDataSource.data = [...results.jsaPaperData.data].sort(
            (a: any, b: any) =>
              new Date(b.date).getTime() - new Date(a.date).getTime()
          );
          this.totalSubmissions = results.jsaData.data.length + results.jsaPaperData.data.length;
        },
        error: (err) => {
          console.error(err);
        },
        complete: () => {
          this.isLoading = false; 
        }
      });
    }
  }

  refreshData(): void {
    this.dataSource.data = [];
    this.paperDataSource.data = [];
    this.totalSubmissions = 0;
    this.form.reset();
    this.searchConducted = false;
    this.isLoading = false; // Reset loading state
  }
}
